import { Box, Theme, Typography } from "@mui/material";
import { Order, PaginationObj, SortingObj, TableHeaderData } from "../../types";
import StrategyDetailsTable from "./StrategyDetailsTable";
import CustomTable from "../../common/customTable";
import { SchemeDetailsObj } from "../../../../redux-store/types/products";
import { FetchStrategyDetailsArgs } from "../types";
import { NO_DATA_ERROR_MESSAGE } from "../../../../utils/constant";

const tableHeaderData: TableHeaderData[] = [
    {
        id: 'schemeName',
        label: 'STRATEGY',
        align: 'left',
        isSortable: true,
    },
    {
        id: 'investedValue',
        label: 'INVESTED VALUE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'marketValue',
        label: 'MARKET VALUE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'exposure',
        label: 'EXPOSURE',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'gainLoss',
        label: 'REALISED GAIN/LOSS',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'inFlow',
        label: 'INFLOW',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'outFlow',
        label: 'OUTFLOW',
        align: 'center',
        isSortable: true,
    },
    {
        id: 'unrealizedGainLoss',
        label: 'UNREALISED GAIN/ LOSS',
        align: 'center',
        isSortable: true,
    },
]



interface PMSStrategyDetailsProps {
    isLoading: boolean;
    fetchStrategyDetails: ({
        sortItem,
        order,
        currentPage,
        rowsPerPage
    }: FetchStrategyDetailsArgs) => void;
    strategyDetailsLoading: boolean;
    strategyDetailsData: SchemeDetailsObj;
    tableSortingObj: SortingObj;
    setTableSortingObj: React.Dispatch<React.SetStateAction<SortingObj>>;
    tablePaginationObj: PaginationObj
    setTablePaginationObj: React.Dispatch<React.SetStateAction<PaginationObj>>;
}

export default function PMSStrategyDetails({
    isLoading,
    setTableSortingObj,
    fetchStrategyDetails,
    tablePaginationObj,
    setTablePaginationObj,
    tableSortingObj,
    strategyDetailsLoading,
    strategyDetailsData,
}: PMSStrategyDetailsProps): JSX.Element {

    const handleSort = (orderBy: string, order: Order) => {
        setTableSortingObj({
            order,
            orderBy
        })

        fetchStrategyDetails({
            sortItem: orderBy === 'gainLoss' ? 'realisedAmount' : orderBy === 'unrealizedGainLoss' ? 'unrealisedAmount' : orderBy,
            order,
            currentPage: tablePaginationObj.currentPage + 1,
            rowsPerPage: tablePaginationObj.rowsPerPage
        })
    }

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTablePaginationObj(prevState => ({
            ...prevState,
            rowsPerPage: Number(event.target.value),
            currentPage: 0,
        }))

        fetchStrategyDetails({
            rowsPerPage: Number(event.target.value),
            sortItem: tableSortingObj.orderBy,
            order: tableSortingObj.order,
        })
    }

    const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        setTablePaginationObj(prevState => ({
            ...prevState,
            currentPage: page
        }))

        fetchStrategyDetails({
            currentPage: page + 1,
            sortItem: tableSortingObj.orderBy,
            order: tableSortingObj.order,
            rowsPerPage: tablePaginationObj.rowsPerPage
        })
    }
    return (
        <Box
            sx={(theme: Theme) => ({
                padding: "35px",
                borderRadius: "25px",
                backgroundColor: theme.palette.common.white,
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                border: `3px solid ${theme.palette.stroke.main}`,
            })}
        >
            {(!(strategyDetailsLoading || isLoading) && !strategyDetailsData.isSuccess) ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                    }}
                >
                    <Typography
                        variant="body_600"
                        sx={(theme: Theme) => ({
                            fontWeight: 500,
                            lineHeight: "22.5px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        {NO_DATA_ERROR_MESSAGE}
                    </Typography>
                </Box>
            ) : (
                <>
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Fund House Performance
                    </Typography>
                    <Box sx={{ marginTop: "25px" }}>
                        <CustomTable
                            isLoading={strategyDetailsLoading || isLoading}
                            tableBody={
                                <StrategyDetailsTable data={strategyDetailsData.data} />
                            }
                            tableHeaderData={tableHeaderData}
                            rowsPerPageOptions={[5, 10, 15, 20]}
                            tableData={strategyDetailsData.data}
                            handleSort={handleSort}
                            tableDataCount={tablePaginationObj.totalRows}
                            rowsPerPage={tablePaginationObj.rowsPerPage}
                            handleRowsPerPageChange={handleRowsPerPageChange}
                            handlePageChange={handlePageChange}
                            currentPage={tablePaginationObj.currentPage}
                            order={tableSortingObj.order}
                            orderBy={tableSortingObj.orderBy}
                            tableBodyLoaderRowCustomStyles={{
                                '& td:first-of-type': {
                                    paddingLeft: "0px"
                                },
                            }}
                            tableHeadRowCustomStyles={{
                                '& th:first-of-type': {
                                    paddingLeft: "0px"
                                }
                            }}
                            tableBodyCustomStyles={{
                                '& tr:last-child td': {
                                    border: 0
                                }
                            }}
                            loadingRowsNum={5}
                        />
                    </Box>
                </>
            )}
        </Box>
    )
}